/* ============================================================
   OOO Listicle LP — interactive behaviours
   Loaded deferred by ooo-lp-listicle-offer.liquid.
   Scroll reveal is handled globally by ooo-motion.js.
   ============================================================ */

(function () {
  'use strict';

  /* ── Purchase option toggle (subscribe / one-time) ───────── */
  function initOfferOpts() {
    var sections = document.querySelectorAll('.ooo-lp-offer-section');
    sections.forEach(function (section) {
      var opts = section.querySelectorAll('.js-ooo-opt');
      if (!opts.length) return;
      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          opts.forEach(function (o) { o.classList.remove('ooo-lp-opt--active'); });
          opt.classList.add('ooo-lp-opt--active');
        });
      });
    });
  }

  /* ── Init on DOMContentLoaded (deferred so DOM is ready) ─── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOfferOpts);
  } else {
    initOfferOpts();
  }
})();
